import Component from "../../lib/Component.js";
import ScrollInView from "./ScrollInView.js";

const MovieShowtimes = ({
  showtimesSelector,
  showtimesRestSelector,
  showtimesLoadButtonSelector,
  showtimesRestToggleCheckboxSelector,
  movieId,
}) => {
  let showtimes = document.querySelector(showtimesSelector);
  let showtimesRest = document.querySelector(showtimesRestSelector);
  let showtimesLoadButton = document.querySelector(showtimesLoadButtonSelector);
  let showtimesRestToggleCheckbox = document.querySelector(showtimesRestToggleCheckboxSelector);

  if (!showtimes || !showtimesRest || !movieId) {
    return Component.noop();
  }

  const loadShowtimes = async () => {
    showtimesLoadButton.className += " disabled";
    showtimesLoadButton.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>' + showtimesLoadButton.innerHTML;
    const now = new Date();
    const date = now.toISOString().split("T")[0].replace(/-/g, "");
    const url = "/api/showtimes/" + date + "/" + movieId;
    try {
      const response = await fetch(url);
      const html = await response.text();
      const firstRestSeparator = '<label for="movie-showtimes-toggle-rest"';
      const [first, rest] = html.split(firstRestSeparator);
      showtimes.innerHTML = first;
      if (rest) {
        showtimesRest.innerHTML = firstRestSeparator + rest;
      } else {
        showtimesRestToggleCheckbox.remove();
        showtimesRest.remove();
      }
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        console.error("Failed to load showtimes:", error);
        showtimes.innerHTML = '<div class="error-message">Failed to load showtimes: ' + error.message + "</div>";
      } else {
        showtimes.remove();
      }
      showtimesRestToggleCheckbox.remove();
      showtimesRest.remove();
      return;
    }

    document.querySelectorAll(".showtime-show").forEach((show) => {
      let [date, time] = show.dataset.datetime.split(" ");
      date = date.split("-");
      time = time.split(":");
      let datetime = new Date(date[0], date[1] - 1, date[2], time[0], time[1], 0);
      if (datetime.getTime() - now < 0) show.className += " past";
    });
  };

  const showtimesInView = ScrollInView({
    observables: [showtimes, showtimesRest],
    unobserveOnEnter: true,
    onEnter: (enteredShowtimes) => {
      if (enteredShowtimes === showtimes) {
        loadShowtimes();
      }
      if (enteredShowtimes === showtimesRest) {
        window.setTimeout(() => {
          showtimesRestToggleCheckbox.checked = true;
        }, 2000);
      }
    },
  });

  return new Component({
    componentName: "MovieShowtimes",
    onMount() {
      if (showtimesLoadButton) {
        showtimesLoadButton.addEventListener("click", loadShowtimes, false);
      }
      showtimesInView.mount();
    },
    onUnmount() {
      if (showtimesLoadButton) {
        showtimesLoadButton.removeEventListener("click", loadShowtimes, false);
      }
      showtimesInView.unmount();
    },
  });
};

export default MovieShowtimes;
